/**
 * Util to download a BLOB Object from BE services
 * @param blobData
 * @param filename
 */
export const downloadBlobFile = (blobData: Blob, filename: string) => {
  const blobUrlData = window.URL.createObjectURL(blobData)
  const linkFile = document.createElement("a")
  linkFile.href = blobUrlData
  linkFile.download = filename
  linkFile.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  )

  setTimeout(() => {
    window.URL.revokeObjectURL(blobUrlData)
    linkFile.remove()
  }, 100)
}

/**
 * Util to convert base64EncodedText into BLOB csv file
 * @param base64String
 * @param type
 */
export const decodeBase64ToBlob = (
  base64String: string,
  type: string = "text/csv",
) => {
  const byteCharacters = atob(base64String) // Decode base64 to binary string
  const byteArrays = []

  // Convert binary string to a byte array
  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    byteArrays.push(new Uint8Array(byteNumbers))
  }

  // Create a Blob from the byte array
  return new Blob(byteArrays, { type })
}
